import * as actionTypes from "../actionTypes";
let orderActionCreators = (data, actionType) => {
  return {
    type: actionTypes[actionType],
    payload: data,
  };
};

export const authUnauthorizedMessage = (reason) => {
  return orderActionCreators(reason, "INVALID_AUTH");
};

export const currentOffice = (current) => {
  return orderActionCreators(current, "CURRENT_OFFICE");
};

export const officeAuth = (mode) => {
  return orderActionCreators(mode, "OFFICE_AUTH");
};

export const getRecoverCode = (mode) => {
  return orderActionCreators(mode, "RECOVER_CODE");
};
export const getUserContact = (mode) => {
  return orderActionCreators(mode, "REGISTER_MOBILE_EMAIL");
};

export const setCaptchaCode = (mode) => {
  return orderActionCreators(mode, "CAPTCHA");
};
export const setRegisterStage = (mode) => {
  return orderActionCreators(mode, "REGISTER_STAGE");
};
export const setLoginRecoverContact = (mode) => {
  return orderActionCreators(mode, "LOGIN_RECOVER_CONTACT");
};
export const setShowCaptcha = (mode) => {
  return orderActionCreators(mode, "SHOW_CAPTCHA");
};
export const setRegisterOTP = (mode) => {
  return orderActionCreators(mode, "REGISTER_OTP");
};
export const setRegisterAddress = (mode) => {
  return orderActionCreators(mode, "REGISTER_ADDRESS");
};
export const setLAT_LNG = (mode) => {
  return orderActionCreators(mode, "LNG_LAT");
};
export const setTraceCode = (mode) => {
  return orderActionCreators(mode, "TRACE_CODE");
};
export const setLoginOTP = (mode) => {
  return orderActionCreators(mode, "LOGIN_OTP");
};
export const setResetCaptcha = (mode) => {
  return orderActionCreators(mode, "RESET_CAPTCHA");
};
export const pwa_modal = (mode) => {
  return orderActionCreators(mode, "PWA");
};
